// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		showPlaceholderProductList: true,
		placeholderProductPerRow: 4,
		placeholderProductGridItemClass: 'grid__item wide--one-fifth large--one-quarter medium-down--one-half',
      	filterTreeMobileStyle: 'style1',
	},
	selector: {
		breadcrumb: '.breadcrumb'
	}
};

var counter = 1;

(function () {
	BoostPFS.inject(this);

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
		console.log(this.data)
		if (!data) data = this.data;
		if (!index) index = this.index;
		if (!totalProduct) totalProduct = this.totalProduct;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		if (index == 1) counter = 1;

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add onSale class
		var itemSaleClass = onSale ? boostPFSTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass);

		var textCenterClass = boostPFSConfig.custom.center_grid_link ? boostPFSTemplate.textCenterClass : '';
		itemHtml = itemHtml.replace(/{{textCenterClass}}/g, textCenterClass);

		var imageSoldOutClass = boostPFSConfig.custom.show_sold_out_circle ? boostPFSTemplate.imageSoldOutClass : '';
		itemHtml = itemHtml.replace(/{{imageSoldOutClass}}/g, imageSoldOutClass);

		// Add onSale label
		var itemSaleLabelHtml = '';
		if (onSale && boostPFSConfig.custom.show_sale_circle) {
			itemSaleLabelHtml = '<span class="badge badge--sale">';
			if (boostPFSConfig.label.sale.length > 7) {
				itemSaleLabelHtml += '<span class="badge__text badge__text--small">';
			} else {
				itemSaleLabelHtml += '<span class="badge__text">';
			}
			itemSaleLabelHtml += boostPFSConfig.label.sale + '</span></span>';
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

		// Add soldOut label
		var itemSoldOutLabeHtml = '';
		if (soldOut && boostPFSConfig.custom.show_sold_out_circle) {
			itemSoldOutLabeHtml = '<span class="badge badge--sold-out">';
			if (boostPFSConfig.label.sold_out.length > 9) {
				itemSoldOutLabeHtml += '<span class="badge__text badge__text--small">';
			} else {
				itemSoldOutLabeHtml += '<span class="badge__text">';
			}
			itemSoldOutLabeHtml += boostPFSConfig.label.sold_out + '</span></span>';
		}
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabeHtml);

		// Add Image style
		var imageStyle = '';
		var itemImagesHtml = '';
		if (data.title != '') {
			if (images.length > 0) {
				var img_id = 'ProductImage-' + images[0]['id'];
				var wrapper_id = 'ProductImageWrapper-' + images[0]['id'] + '';

				var width = boostPFSConfig.custom.product_width;
				var height = 480;
				var aspect_ratio = images[0]['width'] / images[0]['height'];

				var max_width = height * aspect_ratio;
				if (images[0]['height'] < height) {
					var max_height = images[0]['height'];
					max_width = images[0]['width'];
				} else {
					var max_height = width / aspect_ratio;
					if (images[0]['width'] < width) {
						var max_height = images[0]['height'];
						max_width = images[0]['width'];
					} else {
						max_width = width;
					}
				}

				imageStyle = '<style>' +
					'#' + img_id + ' {' +
					'max-width: ' + max_width + 'px;' +
					'max-height: ' + max_height + 'px;' +
					'}' +
					'#' + wrapper_id + ' {' +
					'max-width: ' + max_width + 'px;' +
					'}' +
					'</style>';

				var img_url = Utils.optimizeImage(images[0]['src'], '{width}x');
				itemImagesHtml += '<div id="' + wrapper_id + '" class="product__img-wrapper supports-js">';
				itemImagesHtml += '<div style="padding-top:' + (1 / aspect_ratio * 100) + '%;">' +
					'<img id="' + img_id + '" ' +
					'class="product__img lazyload" ' +
					'src="' + Utils.optimizeImage(images[0]['src'], '300x300') + '" ' +
					'data-src="' + img_url + '" ' +
					'data-widths="[150, 220, 360, 470, 600, 750, 940, 1080, 1296, 1512, 1728, 2048]" ' +
					'data-aspectratio="' + aspect_ratio + '" ' +
					'data-sizes="auto" ' +
					'alt="{{itemTitle}}">' +
					'</div>';
				itemImagesHtml += '</div>';
			} else {
				itemImagesHtml += '<img src="' + boostPFSConfig.general.no_image_url + '" alt="{{itemTitle}}" class="product__img">';
			}
		} else {
			if (counter == 7) counter = 1;
			if (boostPFSConfig.custom.hasOwnProperty('placeholder_svg_tag_' + counter)) {
				itemImagesHtml += boostPFSConfig['custom']['placeholder_svg_tag_' + counter];
			}
			counter++;
		}
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (data.title != '') {
			itemPriceHtml += '<p class="grid-link__meta">';
			if (onSale) {
				itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
				itemPriceHtml += '<s class="grid-link__sale_price">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</s> ';
			}
			if (priceVaries) {
				itemPriceHtml += (boostPFSConfig.label.from_price).replace(/{{ price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
			} else {
				itemPriceHtml += onSale ? '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>' : '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
				itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
			itemPriceHtml += '</p>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		//Add grid Class
		itemHtml = itemHtml.replace(/{{grid_item_width}}/g , boostPFSConfig.custom.grid_item_width);
      
      	// Add quick add
        var itemQuickAddHtml = '';
        var itemBadgeHtml = '';
        var variants = data.variants;
        var tags = data.tags;
        var hasBanner = false;
				var itemQuickAddBottomHtml = '';

        if( data.compare_at_price > data.price ){
            hasBanner = true;
            itemBadgeHtml += '<span class="badge badge--sale">';
                itemBadgeHtml += '<span class="badge__text">Sale</span>';
            itemBadgeHtml += '</span>';
        }

        if( data.inventory_quantity <= 4 ){
            itemBadgeHtml += '<span class="almost-gone-badge">Almost Gone</span>';
            hasBanner = true;
        }

        if( data.inventory_quantity == 1 ){
            itemBadgeHtml += '<span class="last-one-badge">Last One</span>';
            hasBanner = true;
        }

        if( data.inventory_quantity == 0 ){
            itemBadgeHtml += '<span class="badge">Sold Out</span>';
            hasBanner = true;
        }

        for (var i = 0; i < tags.length; i++) {
            if( tags[i] == 'Web Exclusive' ){
                itemBadgeHtml += '<span class="web-exclusive-badge">Web Exclusive</span>';
                hasBanner = true;
            }

            if( tags[i] == 'web exclusive' ){
                itemBadgeHtml += '<span class="web-exclusive-badge">Web Exclusive</span>';
                hasBanner = true;
            }

            if( tags[i] == 'exclusive' ){
                itemBadgeHtml += '<span class="web-exclusive-badge">Web Exclusive</span>';
                hasBanner = true;
            }

            if( tags[i] == 'restock' ){
                itemBadgeHtml += '<span class="restock-badge">Back in Stock</span>';
                hasBanner = true;
            }     

            if( !hasBanner ){
                if ( tags[i].includes("banner") ) {
                    var banner = tags[i].replace("banner -", "");
                    itemBadgeHtml += '<span class="badge">'+ banner +'</span>';
                    hasBanner = true;
                }
            }
        }

        if(hasBanner){
            itemQuickAddHtml += '<div class="quick-add__container has-banner">';
        }else{
            itemQuickAddHtml += '<div class="quick-add__container">';
        }

            itemQuickAddHtml += '<div class="arrow-up__container">';
                itemQuickAddHtml += '<img data-src="//cdn.shopify.com/s/files/1/1763/9697/files/thumbnail-slider-arrow.png?v=16927707682014473011" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" alt="previous thumbnail image">';
            itemQuickAddHtml += '</div>';

            itemQuickAddHtml += '<div class="buttons__container">';
                for (var i = 0; i < variants.length; i++) {
                    itemQuickAddHtml += '<button data-cart-add="'+ variants[i].id +'" data-cart-quantity="1">';
                        if (variants[i].title == 'Default Title') {
                            itemQuickAddHtml += 'Add to cart';
                        }else{
                            itemQuickAddHtml += variants[i].title;
                        }

                    itemQuickAddHtml += '</button>';
                }
            itemQuickAddHtml += '</div>';
        itemQuickAddHtml += '</div>';

        itemHtml = itemHtml.replace(/{{quickAdd}}/g, itemQuickAddHtml);
      
      	// Add Badge
    	itemHtml = itemHtml.replace(/{{badge}}/g, itemBadgeHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		var isVariantHide = false;
		for (var i = 0; i < tags.length; i++) {
			if( tags[i] == 'collection-page-hide-variants' ){
				isVariantHide = true;
			}
		}

		if( !isVariantHide ) {
			itemQuickAddBottomHtml += '<div class="quick-add__container-bottom product-'+ data.id +'">';
				// itemQuickAddBottomHtml += '<div class="buttons__container">';

				// 	for (var i = 0; i < variants.length; i++) {
				// 		itemQuickAddBottomHtml += '<button data-cart-add="'+ variants[i].id +'" data-cart-quantity="1">';
				// 			if (variants[i].title == 'Default Title') {
				// 				itemQuickAddBottomHtml += 'Add to cart';
				// 			}else{
				// 				itemQuickAddBottomHtml += variants[i].title;
				// 			}
				// 		itemQuickAddBottomHtml += '</button>';
				// 	}
				// itemQuickAddBottomHtml += '</div>';
			itemQuickAddBottomHtml += '</div>';
			itemHtml = itemHtml.replace(/{{quickAddBottom}}/g, itemQuickAddBottomHtml);
		}else{
			itemHtml = itemHtml.replace(/{{quickAddBottom}}/g, '');
		}

	return itemHtml;
};

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			jQ(Selector.topSorting).html('');

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbHtml = '';
		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;
			breadcrumbHtml = '<a href="/" title="' + boostPFSConfig.label.breadcrumb_home_link + '">' + boostPFSConfig.label.breadcrumb_home_link + '</a>';
			breadcrumbHtml += ' <span aria-hidden="true" class="breadcrumb__sep">&rsaquo;</span>';
			if (boostPFSConfig.general.current_tags !== null) {
				var currentTags = boostPFSConfig.general.current_tags;
				breadcrumbHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
				breadcrumbHtml += ' <span aria-hidden="true" class="breadcrumb__sep">&rsaquo;</span>';
				breadcrumbHtml += ' <span>' + currentTags.join(' + ') + '</span>';
			} else {
				breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
			}
		}
		return breadcrumbHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		console.log(this.data)

		for (var index = 0; index < data.length; index++) {

			var isVariantHide = false;
			var tags = data[index].tags
			console.log(tags)
			for (var i = 0; i < tags.length; i++) {
				if( tags[i] == 'collection-page-hide-variants' ){
					isVariantHide = true;
				}
			}

			if( !isVariantHide ){
				var variants = data[index].variants;

				var itemQuickAddBottomHtml = '';
				itemQuickAddBottomHtml += '<div class="buttons__container">';
					for (var i = 0; i < variants.length; i++) {
	
						var disabledFlag = '';
						if( !variants[i].available ){
							disabledFlag = 'disabled'
						}
	
	
						itemQuickAddBottomHtml += '<button data-cart-add="'+ variants[i].id +'" data-cart-quantity="1" '+ disabledFlag +'>';
							if (variants[i].title == 'Default Title') {
								itemQuickAddBottomHtml += 'Add to cart';
							}else{
								itemQuickAddBottomHtml += variants[i].title;
							}
						itemQuickAddBottomHtml += '</button>';
					}
				itemQuickAddBottomHtml += '</div>';
				
				$('.quick-add__container-bottom.product-' + data[index].id).empty();
				$('.quick-add__container-bottom.product-' + data[index].id).append(itemQuickAddBottomHtml)
			}
		}
	};

	// Build additional elements after everything is rendered
	FilterResult.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		// recall EqualHeight from theme.js
		var productGridImages = jQuery('.grid-link__image--product');
		if (productGridImages.length && typeof theme.equalHeights === 'function') {
			theme.equalHeights(productGridImages);
		}
	};
})();